import { IAftermarketReturnPolicy } from "api/interfaces/static-pages/aftermarket-return-policy.type";
import Index from "container/returns/Returns";

export default function Returns(props: IAftermarketReturnPolicy) {
  return <Index {...props} />;
}
